import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
import {
  Dic
} from '$utils'
export const tableOption = function (staffShow, operateShow) {
  if (staffShow) {
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: false,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '120px',
      menuAlign: 'center',
      labelPosition: 'right',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 200,
      dialogWidth: '400px',
      viewDialogWidth: '700px',
      viewDialogHeight: 450,
      emptyText: i18n.t('personAccess.title.noData'),
      menu: false,
      column: [{
          label: '姓名',
          prop: 'name',
          search: true,
          addDisplay: false,
          editDisplay: false,
          editDisabled: false,
          viewDisplay: true,
          overHidden: true,
          span: 12,
          rules: [{
            required: true,
            message: '请输入资产名称',
            trigger: 'blur'
          }]
        },
        {
          label: '电话',
          prop: 'phone',
          search: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          editDisabled: false,
          overHidden: true,
          span: 12,
        },
        {
          label: '工号',
          prop: 'workNo',
          hide: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
        },
        {
          label: '部门',
          prop: 'departmentCode',
          searchSlot: true,
          hide: true,
          search: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          span: 12,
        },
        {
          label: '部门',
          prop: 'departmentName',
          hide: false,
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
        },
        {
          label: '岗位',
          prop: 'position',
          search: false,
          searchSlot: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          formslot: true,
          span: 12,
          placeholder: '请选择区域'
        },
        {
          label: '是否在职',
          prop: 'status',
          type: 'select',
          search: true,
          hide: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          labelWidth: '100px',
          viewFormatter: (row, value) => {
            let str = ''
            if (value == -1) {
              str = '全部'
            }
            if (value == 1) {
              str = '在职'
            }
            if (value == 2) {
              str = '离职'
            }
            if (value == 4) {
              str = '未知'
            }
            return str
          },
          formatter: function (row, value) {
            let str = ''
            if (value == -1) {
              str = '全部'
            }
            if (value == 1) {
              str = '在职'
            }
            if (value == 2) {
              str = '离职'
            }
            if (value == 4) {
              str = '未知'
            }
            return str
          },
          dicData: [{
              label: '全部',
              value: -1,
            },
            {
              label: '在职',
              value: 1,
            },
            {
              label: '离职',
              value: 2,
            },
            {
              label: '未知',
              value: 4,
            },
          ],
        },
        {
          label: '图片',
          prop: 'facePicFileCode',
          hide: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          formslot: true,
          viewslot: true,
          span: 24,
        },
        {
          label: '授权',
          prop: 'authStatus',
          type: 'select',
          search: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          span: 12,
          dicData: [{
              label: '已授权',
              value: '1'
            },
            {
              label: '失效',
              value: '2'
            }
          ],
        },
        {
          label: '通行生效时间',
          prop: 'effectiveTime',
          overHidden: true,
          addDisplay: false,
          editDisplay: true,
          viewDisplay: true,
          type: 'datetime',
          columnWidth: '150px',
          span: 24,
          viewSpan: 12,
          rules: [{
            required: true,
            message: "请选择通行生效时间",
            trigger: "blur",
          }],
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          },
          viewFormatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          },
        },
        {
          label: '通行失效时间',
          prop: 'expirationTime',
          value: '',
          overHidden: true,
          addDisplay: false,
          editDisplay: true,
          viewDisplay: true,
          type: 'datetime',
          columnWidth: '150px',
          span: 24,
          viewSpan: 12,
          rules: [{
            required: true,
            message: "请选择通行失效时间",
            trigger: "blur",
          }, ],
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          },
          viewFormatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          },
        },
        {
          label: '人脸道闸名称',
          prop: 'thirdDeviceName',
          align: 'right',
          hide: false,
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          editDisabled: false,
          overHidden: true,
          span: 12,
        },
      ]
    }
  } else {
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      stripe: true,
      page: true,
      maxHeight: '100%',
      header: false,
      selection: false,
      emptyText: i18n.t('personAccess.title.noData'),
      delBtn: false,
      editBtn: false,
      menu: false,
      labelWidth: '120px',
      labelPosition: 'right',
      labelSuffix: '：',
      dialogWidth: '700px',
      viewDialogWidth: '700px',
      viewDialogHeight: 450,
      viewFormSlot: true,
      column: [{
          label: '姓名',
          prop: 'name',
          search: true,
          addDisplay: false,
          editDisplay: false,
          editDisabled: false,
          viewDisplay: true,
          overHidden: true,
          span: 12,
        },
        {
          label: '类型',
          prop: 'personnelType',
          overHidden: true,
          type: 'select',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          viewFormatter: (row, value) => {
            if (Number(value) === 1) {
              return '员工'
            } else if (Number(value) === 2) {
              return '外来人员'
            }
            return '';
          },
          formatter: (row, value) => {
            if (Number(value) === 1) {
              return '员工'
            } else if (Number(value) === 2) {
              return '外来人员'
            }
            return '';
          },
          dicData: [{
              label: '员工',
              value: 1
            },
            {
              label: '外来人员',
              value: 2
            }
          ],
        },
        {
          label: '电话',
          prop: 'phone',
          search: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          editDisabled: false,
          overHidden: true,
          span: 12,
        },
        {
          label: '身份证号',
          prop: 'idCard',
          overHidden: true,
          viewDisplay: true,
          span: 12,
        },
        {
          label: '性别',
          prop: 'sex',
          overHidden: true,
          viewDisplay: true,
          span: 12,
          dicData: Dic.find('SENU001'),
          viewFormatter: (row, value) => {
            if (value) {
              return Dic.findByValue('SENU001', Number(value))
            }
            return ''
          },
          formatter: function (row, value) {
            return value ? Dic.findByValue('SENU001', value) : ''
          },
        },
        {
          label: '图片',
          prop: 'facePicFileCode',
          hide: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          formslot: true,
          viewslot: true,
          span: 12,
        },
        {
          label: '授权',
          prop: 'authStatus',
          type: 'select',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          span: 12,
          dicData: [{
              label: '已授权',
              value: '1'
            },
            {
              label: '失效',
              value: '2'
            }
          ],
        },
        {
          label: '通行生效时间',
          prop: 'effectiveTime',
          search: false,
          overHidden: true,
          addDisplay: false,
          editDisplay: true,
          viewDisplay: true,
          type: 'datetime',
          span: 12,
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '通行失效时间',
          prop: 'expirationTime',
          value: '',
          overHidden: true,
          addDisplay: false,
          editDisplay: true,
          viewDisplay: true,
          type: 'datetime',
          span: 12,
          formatter: function (row, value) {
            return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
          }
        },
        {
          label: '人脸道闸名称',
          prop: 'thirdDeviceName',
          align: 'right',
          hide: false,
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: true,
          editDisabled: false,
          overHidden: true,
          span: 12,
        },
        {
          label: '通行时间',
          prop: 'passageTime',
          type: 'datetimerange',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          search: true,
          hide: true,
          valueFormat: 'timestamp',
          span: 12,
        },
      ]
    }
  }
}